import { render, staticRenderFns } from "./BClassifyCustomerInfo.pug?vue&type=template&id=5311c00a&lang=pug&"
import script from "./BClassifyCustomerInfo.ts?vue&type=script&lang=ts&"
export * from "./BClassifyCustomerInfo.ts?vue&type=script&lang=ts&"
import style0 from "./BClassifyCustomerInfo.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports